import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bsradio-button',
	templateUrl:'./BSRadioButtonPage.html',
	styles: [],
	styleUrls:['./BSRadioButtonPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSRadioButtonPage
{
	mdContent_151 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.buttons.radio.BSRadioButton;
\`\`\``;
	mdContent_152 = `\`\`\`java
new BSRadioButton<>()
\`\`\``;
	mdContent_153 = `\`\`\`java
var group = new BSRadioButtonGroup<>();
group.setForm(myForm);
group.addLabel("Option A");
var input = new InputRadioType<>();
input.setGroup("options");
group.setInput(input);
input.bind("selectedOption");
\`\`\``;
}
